import { Box, Text } from '@mantine/core';
import GameScreen from '../components/GameScreen';

function JoinGameScreen({ roomCode }) {
  return (
    <GameScreen
      backgroundImage="/join-game-bg.png"
      introSound="/Enter the Code to Join the Game.m4a"
      subtitle="join at doodlepoodle.tv"
      contentPosition="bottom"
    >
      <Box
        style={{
          position: 'absolute',
          top: '57%',
          left: '60%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <Text
          style={{
            fontSize: '9rem',
            fontWeight: 700,
            color: '#3B82F6',
            letterSpacing: '0.94rem',
            fontFamily: '"Pangolin", "Fredericka the Great", "Rock Salt", cursive',
            transform: 'rotate(-1deg)',
            textAlign: 'center',
            animation: 'wiggle 4s ease-in-out infinite',
            WebkitTextStroke: '0.5px rgba(37, 99, 235, 0.3)',
          }}
        >
          {roomCode}
        </Text>
      </Box>
      <style>{`
        @keyframes wiggle {
          0%, 100% { transform: rotate(-1deg); }
          25% { transform: rotate(-0.5deg); }
          50% { transform: rotate(-1.5deg); }
          75% { transform: rotate(-0.8deg); }
        }
      `}</style>
    </GameScreen>
  );
}

export default JoinGameScreen;
